import { Component, Input, ViewChild, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, NgForm, FormArray } from '@angular/forms';
import { AuthProvider } from '../../providers/auth/auth';
import _ from 'lodash';
import { BehaviorSubject, Subject } from 'rxjs';
import { InsurersProvider } from '../../providers/insurers/insurers';
import { LoadingController } from 'ionic-angular';
import { PatientProvider } from '../../providers/patient/patient';
import moment from 'moment';
import { UtilityProvider } from '../../providers/utility/utility';
import { DatabaseProvider } from '../../providers/database/database';

@Component({
  selector: 'patient-reimbursement',
  templateUrl: 'patient-reimbursement.html'
})
export class PatientReimbursementComponent implements OnInit {
  private ngUnsubscribe: Subject<any> = new Subject();
  program_id: string;
  program_name: string;
  userid: string;
  user_fullname: string;
  user: any;
  patient: any;
  canDoUCI = false;
  insurers: any[] = [];
  insurers_public: any[] = [];
  dosages: any[] = [];
  exportjson: any;
  exists = false;
  exists_other = false;
  exists_public = false;
  exists_compassionate = false;
  exists_bridging = false;
  exists_fa = false;
  existing_private: any;
  existing_private_other: any;
  existing_public: any;
  existing_compassionate: any;
  existing_bridging: any;
  existing_fa: any;

  private _program_id = new BehaviorSubject<any>([]);
  private _program_name = new BehaviorSubject<any>([]);
  private _patient = new BehaviorSubject<any>([]);

  @Input()
  set programId(value) { this._program_id.next(value); }
  get programId() { return this._program_id.getValue(); }

  @Input()
  set programName(value) { this._program_name.next(value); }
  get programName() { return this._program_name.getValue(); }

  @Input()
  set patientData(value) { this._patient.next(value); }
  get patientData() { return this._patient.getValue(); }

  privateForm: FormGroup; 
  sas: FormArray;
  @ViewChild('formPrivateDirective') private formPrivateDirective: NgForm;

  privateOtherForm: FormGroup; 
  sasother: FormArray;
  @ViewChild('formPrivateOtherDirective') private formPrivateOtherDirective: NgForm;

  publicForm: FormGroup; 
  saspublic: FormArray;
  @ViewChild('formPublicDirective') private formPublicDirective: NgForm;

  compassionateForm: FormGroup; 
  @ViewChild('formCompassionateDirective') private formCompassionateDirective: NgForm;

  bridgingForm: FormGroup; 
  @ViewChild('formBridgingDirective') private formBridgingDirective: NgForm;

  faForm: FormGroup; 
  @ViewChild('formFADirective') private formFADirective: NgForm;

  constructor(
    private fb: FormBuilder,
    private auth: AuthProvider,
    private db: DatabaseProvider,
    private dbInsurers: InsurersProvider,
    private dbPatient: PatientProvider,
    private loadingCtrl: LoadingController,
    private utility: UtilityProvider
    ) {
      this.auth.getCurrentUser().then(user => {
        this.userid = user.id;
        this.user_fullname = user.first_name + ' ' + user.last_name;
        this.user = { id: user.id, name: user.first_name + ' ' + user.last_name };
      });
  }

  ngOnInit()  {
    this._program_id
    .takeUntil(this.ngUnsubscribe)
    .subscribe(x => {
      // console.log('Program ID on Summary: ', x)
        this.program_id = x
        this.getPayers();
        this.getDoses();
    });

    this._program_name
    .takeUntil(this.ngUnsubscribe)
    .subscribe(x => {
      // console.log('Program Name on Summary: ', x)
        this.program_name = x
    });

    this._patient
    // .pipe(first())
    .takeUntil(this.ngUnsubscribe)
    .subscribe(x => {
      // console.log('Patient on Summary: ', x)
        this.createPrivateForm();
        this.createPrivateOtherForm();
        this.createPublicForm();
        this.createCompassionateForm();
        this.createBridgingForm();
        this.patient = x
        if(this.patient.therapy !== 'Lenvima')  {
          this.createFAForm();
        }
        if(this.patient.first_name && this.patient.last_name && this.patient.address && this.patient.city && this.patient.province && this.patient.postal_code && this.patient.language && this.patient.gender && this.patient.dob) {
          this.canDoUCI = true;
        } else {
          this.canDoUCI = false;
        }
        /******************* Private Reimbursement *************************/
        this.existing_private = this.patient.reimbursement_private;
        if (this.existing_private) {
          this.exists = true;
          this.existing_private.priority = this.existing_private.priority.toString();
          if (this.existing_private.active_date) {
            if (!(this.existing_private.active_date instanceof Date)) {
              this.existing_private.active_date = new Date(this.existing_private.active_date.seconds * 1000);
            }
          }
          if (this.existing_private.inactive_date) {
            if (!(this.existing_private.inactive_date instanceof Date)) {
              this.existing_private.inactive_date = new Date(this.existing_private.inactive_date.seconds * 1000);
            }
          }
          if (this.existing_private.payer_contact_date) {
            if (!(this.existing_private.payer_contact_date instanceof Date)) {
              this.existing_private.payer_contact_date = new Date(this.existing_private.payer_contact_date.seconds * 1000);
            }
          }
          if (this.existing_private.reimbursement_complete_date) {
            if (!(this.existing_private.reimbursement_complete_date instanceof Date)) {
              this.existing_private.reimbursement_complete_date = new Date(this.existing_private.reimbursement_complete_date.seconds * 1000);
            }
          }
          if (this.existing_private.benefit_start_date) {
            if (!(this.existing_private.benefit_start_date instanceof Date)) {
              this.existing_private.benefit_start_date = new Date(this.existing_private.benefit_start_date.seconds * 1000);
            }
          }
          if (this.existing_private.benefit_end_date) {
            if (!(this.existing_private.benefit_end_date instanceof Date)) {
              this.existing_private.benefit_end_date = new Date(this.existing_private.benefit_end_date.seconds * 1000);
            }
          }
          for (let idx = 0; idx < this.existing_private.sas.length; idx++) {

            if (this.existing_private.sas[idx].investigation_date) {
              if (!(this.existing_private.sas[idx].investigation_date instanceof Date)) {
                this.existing_private.sas[idx].investigation_date = new Date(this.existing_private.sas[idx].investigation_date.seconds * 1000);
              }
            }

            if (this.existing_private.sas[idx].expiration_date) {
              if (!(this.existing_private.sas[idx].expiration_date instanceof Date)) {
                this.existing_private.sas[idx].expiration_date = new Date(this.existing_private.sas[idx].expiration_date.seconds * 1000);
              }
            }

            if (this.existing_private.sas[idx].payer_requested_date) {
              if (!(this.existing_private.sas[idx].payer_requested_date instanceof Date)) {
                this.existing_private.sas[idx].payer_requested_date = new Date(this.existing_private.sas[idx].payer_requested_date.seconds * 1000);
              }
            }

            if (this.existing_private.sas[idx].patient_submitted_date) {
              if (!(this.existing_private.sas[idx].patient_submitted_date instanceof Date)) {
                this.existing_private.sas[idx].patient_submitted_date = new Date(this.existing_private.sas[idx].patient_submitted_date.seconds * 1000);
              }
            }

            if (this.existing_private.sas[idx].patient_reply_date) {
              if (!(this.existing_private.sas[idx].patient_reply_date instanceof Date)) {
                this.existing_private.sas[idx].patient_reply_date = new Date(this.existing_private.sas[idx].patient_reply_date.seconds * 1000);
              }
            }

            if (this.existing_private.sas[idx].physician_submitted_date) {
              if (!(this.existing_private.sas[idx].physician_submitted_date instanceof Date)) {
                this.existing_private.sas[idx].physician_submitted_date = new Date(this.existing_private.sas[idx].physician_submitted_date.seconds * 1000);
              }
            }

            if (this.existing_private.sas[idx].physician_reply_date) {
              if (!(this.existing_private.sas[idx].physician_reply_date instanceof Date)) {
                this.existing_private.sas[idx].physician_reply_date = new Date(this.existing_private.sas[idx].physician_reply_date.seconds * 1000);
              }
            }

            if (this.existing_private.sas[idx].payer_submitted_date) {
              if (!(this.existing_private.sas[idx].payer_submitted_date instanceof Date)) {
                this.existing_private.sas[idx].payer_submitted_date = new Date(this.existing_private.sas[idx].payer_submitted_date.seconds * 1000);
              }
            }

            if (this.existing_private.sas[idx].payer_reply_date) {
              if (!(this.existing_private.sas[idx].payer_reply_date instanceof Date)) {
                this.existing_private.sas[idx].payer_reply_date = new Date(this.existing_private.sas[idx].payer_reply_date.seconds * 1000);
              }
            }

            if (this.existing_private.sas[idx].field_visit_required_date) {
              if (!(this.existing_private.sas[idx].field_visit_required_date instanceof Date)) {
                this.existing_private.sas[idx].field_visit_required_date = new Date(this.existing_private.sas[idx].field_visit_required_date.seconds * 1000);
              }
            }

            this.addSA();
          }
          setTimeout(() => {
            this.privateForm.patchValue(this.existing_private);
          }, 0);


        } else {  
          this.exists = false;
        }

          /******************* Private Other Reimbursement *************************/
        this.existing_private_other = this.patient.reimbursement_private_other;
        if (this.existing_private_other) {
          this.exists_other = true;
          this.existing_private_other.priority = this.existing_private_other.priority.toString();
          if (this.existing_private_other.active_date) {
            if (!(this.existing_private_other.active_date instanceof Date)) {
              this.existing_private_other.active_date = new Date(this.existing_private_other.active_date.seconds * 1000);
            }
          }
          if (this.existing_private_other.inactive_date) {
            if (!(this.existing_private_other.inactive_date instanceof Date)) {
              this.existing_private_other.inactive_date = new Date(this.existing_private_other.inactive_date.seconds * 1000);
            }
          }
          if (this.existing_private_other.payer_contact_date) {
            if (!(this.existing_private_other.payer_contact_date instanceof Date)) {
              this.existing_private_other.payer_contact_date = new Date(this.existing_private_other.payer_contact_date.seconds * 1000);
            }
          }
          if (this.existing_private_other.reimbursement_complete_date) {
            if (!(this.existing_private_other.reimbursement_complete_date instanceof Date)) {
              this.existing_private_other.reimbursement_complete_date = new Date(this.existing_private_other.reimbursement_complete_date.seconds * 1000);
            }
          }
          if (this.existing_private_other.benefit_start_date) {
            if (!(this.existing_private_other.benefit_start_date instanceof Date)) {
              this.existing_private_other.benefit_start_date = new Date(this.existing_private_other.benefit_start_date.seconds * 1000);
            }
          }
          if (this.existing_private_other.benefit_end_date) {
            if (!(this.existing_private_other.benefit_end_date instanceof Date)) {
              this.existing_private_other.benefit_end_date = new Date(this.existing_private_other.benefit_end_date.seconds * 1000);
            }
          }
          if (this.existing_private_other.policy_holder_dob) {
            if (!(this.existing_private_other.policy_holder_dob instanceof Date)) {
              this.existing_private_other.policy_holder_dob = new Date(this.existing_private_other.policy_holder_dob.seconds * 1000);
            }
          }
          for (let idx = 0; idx < this.existing_private_other.sas.length; idx++) {

            if (this.existing_private_other.sas[idx].investigation_date) {
              if (!(this.existing_private_other.sas[idx].investigation_date instanceof Date)) {
                this.existing_private_other.sas[idx].investigation_date = new Date(this.existing_private_other.sas[idx].investigation_date.seconds * 1000);
              }
            }

            if (this.existing_private_other.sas[idx].expiration_date) {
              if (!(this.existing_private_other.sas[idx].expiration_date instanceof Date)) {
                this.existing_private_other.sas[idx].expiration_date = new Date(this.existing_private_other.sas[idx].expiration_date.seconds * 1000);
              }
            }

            if (this.existing_private_other.sas[idx].payer_requested_date) {
              if (!(this.existing_private_other.sas[idx].payer_requested_date instanceof Date)) {
                this.existing_private_other.sas[idx].payer_requested_date = new Date(this.existing_private_other.sas[idx].payer_requested_date.seconds * 1000);
              }
            }

            if (this.existing_private_other.sas[idx].patient_submitted_date) {
              if (!(this.existing_private_other.sas[idx].patient_submitted_date instanceof Date)) {
                this.existing_private_other.sas[idx].patient_submitted_date = new Date(this.existing_private_other.sas[idx].patient_submitted_date.seconds * 1000);
              }
            }

            if (this.existing_private_other.sas[idx].patient_reply_date) {
              if (!(this.existing_private_other.sas[idx].patient_reply_date instanceof Date)) {
                this.existing_private_other.sas[idx].patient_reply_date = new Date(this.existing_private_other.sas[idx].patient_reply_date.seconds * 1000);
              }
            }

            if (this.existing_private_other.sas[idx].physician_submitted_date) {
              if (!(this.existing_private_other.sas[idx].physician_submitted_date instanceof Date)) {
                this.existing_private_other.sas[idx].physician_submitted_date = new Date(this.existing_private_other.sas[idx].physician_submitted_date.seconds * 1000);
              }
            }

            if (this.existing_private_other.sas[idx].physician_reply_date) {
              if (!(this.existing_private_other.sas[idx].physician_reply_date instanceof Date)) {
                this.existing_private_other.sas[idx].physician_reply_date = new Date(this.existing_private_other.sas[idx].physician_reply_date.seconds * 1000);
              }
            }

            if (this.existing_private_other.sas[idx].payer_submitted_date) {
              if (!(this.existing_private_other.sas[idx].payer_submitted_date instanceof Date)) {
                this.existing_private_other.sas[idx].payer_submitted_date = new Date(this.existing_private_other.sas[idx].payer_submitted_date.seconds * 1000);
              }
            }

            if (this.existing_private_other.sas[idx].payer_reply_date) {
              if (!(this.existing_private_other.sas[idx].payer_reply_date instanceof Date)) {
                this.existing_private_other.sas[idx].payer_reply_date = new Date(this.existing_private_other.sas[idx].payer_reply_date.seconds * 1000);
              }
            }

            if (this.existing_private_other.sas[idx].field_visit_required_date) {
              if (!(this.existing_private_other.sas[idx].field_visit_required_date instanceof Date)) {
                this.existing_private_other.sas[idx].field_visit_required_date = new Date(this.existing_private_other.sas[idx].field_visit_required_date.seconds * 1000);
              }
            }

            this.addOtherSA();
          }

          setTimeout(() => {
            this.privateOtherForm.patchValue(this.existing_private_other);
          }, 0);


        } else {  
          this.exists_other = false;
        }


        /******************* Public Reimbursement *************************/
        this.existing_public = this.patient.reimbursement_public;
        if (this.existing_public) {
          this.exists = true;
          this.existing_public.priority = this.existing_public.priority.toString();
          if (this.existing_public.active_date) {
            if (!(this.existing_public.active_date instanceof Date)) {
              this.existing_public.active_date = new Date(this.existing_public.active_date.seconds * 1000);
            }
          }
          if (this.existing_public.inactive_date) {
            if (!(this.existing_public.inactive_date instanceof Date)) {
              this.existing_public.inactive_date = new Date(this.existing_public.inactive_date.seconds * 1000);
            }
          }
          if (this.existing_public.payer_contact_date) {
            if (!(this.existing_public.payer_contact_date instanceof Date)) {
              this.existing_public.payer_contact_date = new Date(this.existing_public.payer_contact_date.seconds * 1000);
            }
          }
          if (this.existing_public.reimbursement_complete_date) {
            if (!(this.existing_public.reimbursement_complete_date instanceof Date)) {
              this.existing_public.reimbursement_complete_date = new Date(this.existing_public.reimbursement_complete_date.seconds * 1000);
            }
          }
          if (this.existing_public.benefit_start_date) {
            if (!(this.existing_public.benefit_start_date instanceof Date)) {
              this.existing_public.benefit_start_date = new Date(this.existing_public.benefit_start_date.seconds * 1000);
            }
          }
          if (this.existing_public.benefit_end_date) {
            if (!(this.existing_public.benefit_end_date instanceof Date)) {
              this.existing_public.benefit_end_date = new Date(this.existing_public.benefit_end_date.seconds * 1000);
            }
          }
          for (let idx = 0; idx < this.existing_public.sas.length; idx++) {

            if (this.existing_public.sas[idx].investigation_date) {
              if (!(this.existing_public.sas[idx].investigation_date instanceof Date)) {
                this.existing_public.sas[idx].investigation_date = new Date(this.existing_public.sas[idx].investigation_date.seconds * 1000);
              }
            }

            if (this.existing_public.sas[idx].expiration_date) {
              if (!(this.existing_public.sas[idx].expiration_date instanceof Date)) {
                this.existing_public.sas[idx].expiration_date = new Date(this.existing_public.sas[idx].expiration_date.seconds * 1000);
              }
            }

            if (this.existing_public.sas[idx].payer_requested_date) {
              if (!(this.existing_public.sas[idx].payer_requested_date instanceof Date)) {
                this.existing_public.sas[idx].payer_requested_date = new Date(this.existing_public.sas[idx].payer_requested_date.seconds * 1000);
              }
            }

            if (this.existing_public.sas[idx].patient_submitted_date) {
              if (!(this.existing_public.sas[idx].patient_submitted_date instanceof Date)) {
                this.existing_public.sas[idx].patient_submitted_date = new Date(this.existing_public.sas[idx].patient_submitted_date.seconds * 1000);
              }
            }

            if (this.existing_public.sas[idx].patient_reply_date) {
              if (!(this.existing_public.sas[idx].patient_reply_date instanceof Date)) {
                this.existing_public.sas[idx].patient_reply_date = new Date(this.existing_public.sas[idx].patient_reply_date.seconds * 1000);
              }
            }

            if (this.existing_public.sas[idx].physician_submitted_date) {
              if (!(this.existing_public.sas[idx].physician_submitted_date instanceof Date)) {
                this.existing_public.sas[idx].physician_submitted_date = new Date(this.existing_public.sas[idx].physician_submitted_date.seconds * 1000);
              }
            }

            if (this.existing_public.sas[idx].physician_reply_date) {
              if (!(this.existing_public.sas[idx].physician_reply_date instanceof Date)) {
                this.existing_public.sas[idx].physician_reply_date = new Date(this.existing_public.sas[idx].physician_reply_date.seconds * 1000);
              }
            }

            if (this.existing_public.sas[idx].payer_submitted_date) {
              if (!(this.existing_public.sas[idx].payer_submitted_date instanceof Date)) {
                this.existing_public.sas[idx].payer_submitted_date = new Date(this.existing_public.sas[idx].payer_submitted_date.seconds * 1000);
              }
            }

            if (this.existing_public.sas[idx].payer_reply_date) {
              if (!(this.existing_public.sas[idx].payer_reply_date instanceof Date)) {
                this.existing_public.sas[idx].payer_reply_date = new Date(this.existing_public.sas[idx].payer_reply_date.seconds * 1000);
              }
            }

            if (this.existing_public.sas[idx].field_visit_required_date) {
              if (!(this.existing_public.sas[idx].field_visit_required_date instanceof Date)) {
                this.existing_public.sas[idx].field_visit_required_date = new Date(this.existing_public.sas[idx].field_visit_required_date.seconds * 1000);
              }
            }

            this.addPublicSA();
          }
          setTimeout(() => {
            this.publicForm.patchValue(this.existing_public);
          }, 0);


        } else {  
          this.exists = false;
          this.exists_public = false;
        }


         /******************* Compassionate Reimbursement *************************/
         this.existing_compassionate = this.patient.reimbursement_compassionate;
         if (this.existing_compassionate) {
           this.exists = true;
           if (this.existing_compassionate.active_date) {
             if (!(this.existing_compassionate.active_date instanceof Date)) {
               this.existing_compassionate.active_date = new Date(this.existing_compassionate.active_date.seconds * 1000);
             }
           }
           if (this.existing_compassionate.inactive_date) {
             if (!(this.existing_compassionate.inactive_date instanceof Date)) {
               this.existing_compassionate.inactive_date = new Date(this.existing_compassionate.inactive_date.seconds * 1000);
             }
           }
           if (this.existing_compassionate.decision_date) {
            if (!(this.existing_compassionate.decision_date instanceof Date)) {
              this.existing_compassionate.decision_date = new Date(this.existing_compassionate.decision_date.seconds * 1000);
            }
          }
           if (this.existing_compassionate.start_date) {
             if (!(this.existing_compassionate.start_date instanceof Date)) {
               this.existing_compassionate.start_date = new Date(this.existing_compassionate.start_date.seconds * 1000);
             }
           }
           if (this.existing_compassionate.expiry_date) {
             if (!(this.existing_compassionate.expiry_date instanceof Date)) {
               this.existing_compassionate.expiry_date = new Date(this.existing_compassionate.expiry_date.seconds * 1000);
             }
           } 
           setTimeout(() => {
            this.compassionateForm.patchValue(this.existing_compassionate);
          }, 0);
         } else {  
           this.exists = false;
           this.existing_compassionate = false;
         }

         /******************* Bridging Reimbursement *************************/
         this.existing_bridging = this.patient.reimbursement_bridging;
         if (this.existing_bridging) {
           this.exists = true;
           if (this.existing_bridging.active_date) {
             if (!(this.existing_bridging.active_date instanceof Date)) {
               this.existing_bridging.active_date = new Date(this.existing_bridging.active_date.seconds * 1000);
             }
           }
           if (this.existing_bridging.inactive_date) {
             if (!(this.existing_bridging.inactive_date instanceof Date)) {
               this.existing_bridging.inactive_date = new Date(this.existing_bridging.inactive_date.seconds * 1000);
             }
           }
           if (this.existing_bridging.escalation_request_date) {
            if (!(this.existing_bridging.escalation_request_date instanceof Date)) {
              this.existing_bridging.escalation_request_date = new Date(this.existing_bridging.escalation_request_date.seconds * 1000);
            }
          }
          if (this.existing_bridging.escalation_response_date) {
            if (!(this.existing_bridging.escalation_response_date instanceof Date)) {
              this.existing_bridging.escalation_response_date = new Date(this.existing_bridging.escalation_response_date.seconds * 1000);
            }
          }
           if (this.existing_bridging.start_date) {
             if (!(this.existing_bridging.start_date instanceof Date)) {
               this.existing_bridging.start_date = new Date(this.existing_bridging.start_date.seconds * 1000);
             }
           }
           if (this.existing_bridging.expiry_date) {
             if (!(this.existing_bridging.expiry_date instanceof Date)) {
               this.existing_bridging.expiry_date = new Date(this.existing_bridging.expiry_date.seconds * 1000);
             }
           } 
           setTimeout(() => {
            this.bridgingForm.patchValue(this.existing_bridging);
          }, 0);
         } else {  
           this.exists = false;
           this.existing_bridging = false;
         }


         /******************* FA Reimbursement *************************/
         this.existing_fa = this.patient.reimbursement_fa;
         if (this.existing_fa) {
           this.exists = true;
           if (this.existing_fa.active_date) {
             if (!(this.existing_fa.active_date instanceof Date)) {
               this.existing_fa.active_date = new Date(this.existing_fa.active_date.seconds * 1000);
             }
           }
           if (this.existing_fa.inactive_date) {
             if (!(this.existing_fa.inactive_date instanceof Date)) {
               this.existing_fa.inactive_date = new Date(this.existing_fa.inactive_date.seconds * 1000);
             }
           }
           if (this.existing_fa.start_date) {
             if (!(this.existing_fa.start_date instanceof Date)) {
               this.existing_fa.start_date = new Date(this.existing_fa.start_date.seconds * 1000);
             }
           }
           if (this.existing_fa.expiry_date) {
             if (!(this.existing_fa.expiry_date instanceof Date)) {
               this.existing_fa.expiry_date = new Date(this.existing_fa.expiry_date.seconds * 1000);
             }
           } 
           setTimeout(() => {
            if(this.patient.therapy !== 'Lenvima')  {
              this.faForm.patchValue(this.existing_fa);
            }
          }, 0);
         } else {  
           this.exists = false;
           this.existing_fa = false;
         }
    });
  }

  ngOnDestroy() {
    console.log('Leave patient reimbursement and destroy subscriptions');
    this._patient.unsubscribe();
    this._program_id.unsubscribe();
    this._program_name.unsubscribe();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  async getUCIInfo()  {
    const loading = this.loadingCtrl.create({});
    loading.present();

    // do something
    console.log('Start API calls')
    const ucipatient = {
      first_name: this.patient.first_name,
      last_name: this.patient.last_name,
      address: this.patient.address,
      city: this.patient.city,
      province: this.patient.province,
      postal_code: this.patient.postal_code,
      language: this.patient.language,
      gender: this.patient.gender,
      dob: this.patient.dob ? moment(this.patient.dob.seconds * 1000).format('YYYY-MM-DD') : null,
      coveragetype: 'PUBLIC'
    }
    console.log(ucipatient);
    this.dbPatient.getUCINumber(ucipatient)
    .then(ucidata => {
      console.log('UCI Data: ', ucidata);
      this.dbPatient.addReimbursement(this.program_id, this.patient.id, 'reimbursement_fa', ucidata, this.user).then(() => {
        this.utility.presentToast('The UCI number was retrieved and saved as an FA session.')
        loading.dismiss();
      })
      .catch(err => {
        throw(err);
      });
    })
    .catch(err => {
      console.log('UCI Error: ', err);
      loading.dismiss();
      this.utility.presentToast('There was an error retrieving the UCI number.  Please try again.')
    })
  }

  async createPrivateForm()  {
    let phoneregex: RegExp = /^\+[1-9]\d{1,14}(\se?x?t?(\d*))?$/

    this.privateForm = this.fb.group({
      active: [null, [Validators.required]],
      active_date: [null],
      inactive_date: [null],
      priority: [null, [Validators.required]],
      payer: [null, [Validators.required]],
      payer_contact_date: [null],
      reimbursement_complete_date: [null],
      policy_number: [null],
      certificate_number: [null],
      carrier_number: [null],
      employer: [null],
      phone_number_specific: [null, [Validators.pattern(phoneregex)]],
      benefit_start_date: [null],
      benefit_end_date: [null],
      supply_limit: [null],
      assignment_of_benefits: [null],
      adjudication_type: [null],
      coverage: [null],
      copayment: [null],
      copayment_max: [null],
      premium: [null],
      deductible: [null],
      deductible_frequency: [null],
      max_amount: [null],
      max_amount_frequency: [null],
      outcome_initial: [null],
      outcome_final: [null],
      outcome_final_denied_reason: [null],
      sas: this.fb.array([]),
      notes: [null]
    });

    this.onFormChanges();
  }

  async createPrivateOtherForm()  {
    let phoneregex: RegExp = /^\+[1-9]\d{1,14}(\se?x?t?(\d*))?$/

    this.privateOtherForm = this.fb.group({
      active: [null, [Validators.required]],
      active_date: [null],
      inactive_date: [null],
      priority: [null, [Validators.required]],
      payer: [null, [Validators.required]],
      payer_contact_date: [null],
      reimbursement_complete_date: [null],
      policy_holder_first_name: [null],
      policy_holder_last_name: [null],
      policy_holder_dob: [null],
      policy_holder_type: [null],
      policy_holder_consent: [null],
      policy_number: [null],
      certificate_number: [null],
      carrier_number: [null],
      employer: [null],
      phone_number_specific: [null, [Validators.pattern(phoneregex)]],
      benefit_start_date: [null],
      benefit_end_date: [null],
      supply_limit: [null],
      assignment_of_benefits: [null],
      adjudication_type: [null],
      coverage: [null],
      copayment: [null],
      copayment_max: [null],
      premium: [null],
      deductible: [null],
      deductible_frequency: [null],
      max_amount: [null],
      max_amount_frequency: [null],
      outcome_initial: [null],
      outcome_final: [null],
      outcome_final_denied_reason: [null],
      sas: this.fb.array([]),
      notes: [null]
    });

    this.onOtherFormChanges();
  }

  addSA(): void {
    this.sas = this.privateForm.get('sas') as FormArray;
    this.sas.push(this.createSA());
  }

  deleteSA(idx): void {
    this.sas.removeAt(idx);
  }

  addOtherSA(): void {
    this.sasother = this.privateOtherForm.get('sas') as FormArray;
    this.sasother.push(this.createSA());
  }

  deleteOtherSA(idx): void {
    this.sasother.removeAt(idx);
  }


  async createPublicForm()  {
    let phoneregex: RegExp = /^\+[1-9]\d{1,14}(\se?x?t?(\d*))?$/

    this.publicForm = this.fb.group({
      active: [null, [Validators.required]],
      active_date: [null],
      inactive_date: [null],
      priority: [null, [Validators.required]],
      payer: [null, [Validators.required]],
      payer_contact_date: [null],
      reimbursement_complete_date: [null],
      file_number: [null],
      phone_number_specific: [null, [Validators.pattern(phoneregex)]],
      benefit_start_date: [null],
      benefit_end_date: [null],
      supply_limit: [null],
      assignment_of_benefits: [null],
      adjudication_type: [null],
      coverage: [null],
      copayment: [null],
      copayment_max: [null],
      premium: [null],
      deductible: [null],
      deductible_frequency: [null],
      max_amount: [null],
      max_amount_frequency: [null],
      outcome_initial: [null],
      outcome_final: [null],
      outcome_final_denied_reason: [null],
      sas: this.fb.array([]),
      notes: [null]
    });

    this.onPublicFormChanges();
  }
  

  addPublicSA(): void {
    this.saspublic = this.publicForm.get('sas') as FormArray;
    this.saspublic.push(this.createSA());
  }

  deletePublicSA(idx): void {
    this.saspublic.removeAt(idx);
  }

  createSA(): FormGroup {
    return this.fb.group({
      type: [null, [Validators.required]],
      investigation_date: [null, [Validators.required]],
      status: [null, [Validators.required]],
      expiration_date: [null],
      payer_requested_date: [null],
      patient_submitted_date: [null],
      patient_reply_date: [null],
      physician_submitted_date: [null],
      physician_reply_date: [null],
      payer_submitted_date: [null],
      payer_reply_date: [null],
      field_visit_required_date: [null]
    });
  }

  async createCompassionateForm()  {
    this.compassionateForm = this.fb.group({
      active: [null, [Validators.required]],
      active_date: [null],
      inactive_date: [null],
      type: [null],
      decision_by: [null],
      decision_date: [null],
      dose: [null],
      quantity: [null],
      start_date: [null],
      expiry_date: [null],
      status: [null],
      notes: [null]
    });
    this.onCompassionateFormChanges();
  }

  async createBridgingForm()  {
    this.bridgingForm = this.fb.group({
      active: [null, [Validators.required]],
      active_date: [null],
      inactive_date: [null],
      canadian_resident: [null],
      canadian_physician: [null],
      type: [null],
      category: [null],
      escalation_request_date: [null],
      escalation_reason: [null],
      escalation_response_date: [null],
      escalation_add_info: [null],
      escalation_status: [null],
      escalation_assessed_by: [null],
      dose: [null],
      quantity: [null],
      start_date: [null],
      expiry_date: [null],
      status: [null],
      notes: [null]
    });
    this.onBridgingFormChanges();
  }

async createFAForm()  {
  this.faForm = this.fb.group({
    active: [null, [Validators.required]],
    active_date: [null],
    inactive_date: [null],
    copayment: [null],
    copayment_amount: [null],
    start_date: [null],
    expiry_date: [null],
    status: [null],
    notes: [null]
  });
  this.onFAFormChanges();
}


  async getPayers() {
    return new Promise((resolve) => {
      this.dbInsurers
      .listInsurers(this.program_id)
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .takeUntil(this.ngUnsubscribe)
      .subscribe((insurers) => {
        this.insurers = insurers.filter(x => x.type === 'Private');
        this.insurers_public = insurers.filter(x => x.type === 'Public');
        resolve();
      });
    });
  }

  onPayerChange(payer)  {
    console.log('Payer: ', payer);
  }

  displayFn(object?: any): string | undefined {
    return object ? object.name : undefined;
  }

  public objectComparisonFunction = function( option, value ) : boolean {
    if(option && value) return option.id === value.id;
    else return null;
  }

  getDoses()  {
    this.db
    .getTherapyByProgram(this.program_id)
    .snapshotChanges()
    .map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data() as any;
        data.id = a.payload.doc.id;
        return data;
      });
    })
    .takeUntil(this.ngUnsubscribe)
    .subscribe((therapies) => {
      if (this.patient.therapy) {
        this.dosages = _.filter(therapies, therapy => therapy.name === this.patient.therapy)[0]['dosing'];
      }
    });
  }

  savePrivate() {
    const loading = this.loadingCtrl.create({});
    loading.present().then(() => {
      let reimbursement = this.privateForm.value;
      reimbursement.priority = parseInt(reimbursement.priority);
      reimbursement.type = 'private';
      const patient = {
        id: this.patient.id,
        first_name: this.patient.first_name,
        last_name: this.patient.last_name,
        program_patient_id: this.patient.program_patient_id
      }
      reimbursement = { patient: patient, ...reimbursement };
      if (this.exists)  {
        reimbursement.id = this.existing_private.id;
        this.dbPatient.updateReimbursement(this.program_id, this.patient.id, 'reimbursement_private', reimbursement, this.user).then(() => {
          setTimeout(() => {
            loading.dismiss();
          },250);
        })
      } else {
        this.dbPatient.addReimbursement(this.program_id, this.patient.id, 'reimbursement_private', reimbursement, this.user).then(() => {
          setTimeout(() => {
            loading.dismiss();
          },250);
        })
      }
    });  
  }

  savePrivateOther()  {
    const loading = this.loadingCtrl.create({});
    loading.present().then(() => {
      let reimbursement = this.privateOtherForm.value;
      reimbursement.priority = parseInt(reimbursement.priority);
      reimbursement.type = 'private other';
      if (this.exists_other)  {
        reimbursement.id = this.existing_private_other.id;
        this.dbPatient.updateReimbursement(this.program_id, this.patient.id, 'reimbursement_private_other', reimbursement, this.user).then(() => {
          setTimeout(() => {
            loading.dismiss();
          },250);
        })
      } else {
        this.dbPatient.addReimbursement(this.program_id, this.patient.id, 'reimbursement_private_other', reimbursement, this.user).then(() => {
          setTimeout(() => {
            loading.dismiss();
          },250);
        })
      }
    }); 
  }

  savePublic() {
    const loading = this.loadingCtrl.create({});
    loading.present().then(() => {
      let reimbursement = this.publicForm.value;
      reimbursement.priority = parseInt(reimbursement.priority);
      reimbursement.type = 'public';
      if (this.exists_public)  {
        reimbursement.id = this.existing_public.id;
        this.dbPatient.updateReimbursement(this.program_id, this.patient.id, 'reimbursement_public', reimbursement, this.user).then(() => {
          setTimeout(() => {
            loading.dismiss();
          },250);
        })
      } else {
        this.dbPatient.addReimbursement(this.program_id, this.patient.id, 'reimbursement_public', reimbursement, this.user).then(() => {
          setTimeout(() => {
            loading.dismiss();
          },250);
        })
      }
    });  
  }

  saveCompassionate() {
    const loading = this.loadingCtrl.create({});
    loading.present().then(() => {
      let reimbursement = this.compassionateForm.value;
      reimbursement.priority = null;
      if (this.existing_compassionate)  {
        reimbursement.id = this.existing_compassionate.id;
        this.dbPatient.updateReimbursement(this.program_id, this.patient.id, 'reimbursement_compassionate', reimbursement, this.user).then(() => {
          setTimeout(() => {
            loading.dismiss();
          },250);
        })
      } else {
        this.dbPatient.addReimbursement(this.program_id, this.patient.id, 'reimbursement_compassionate', reimbursement, this.user).then(() => {
          setTimeout(() => {
            loading.dismiss();
          },250);
        })
      }
    }); 
  }

  saveBridging() {
    const loading = this.loadingCtrl.create({});
    loading.present().then(() => {
      let reimbursement = this.bridgingForm.value;
      reimbursement.priority = null;
      if (this.existing_bridging)  {
        reimbursement.id = this.existing_bridging.id;
        this.dbPatient.updateReimbursement(this.program_id, this.patient.id, 'reimbursement_bridging', reimbursement, this.user).then(() => {
          setTimeout(() => {
            loading.dismiss();
          },250);
        })
      } else {
        this.dbPatient.addReimbursement(this.program_id, this.patient.id, 'reimbursement_bridging', reimbursement, this.user).then(() => {
          setTimeout(() => {
            loading.dismiss();
          },250);
        })
      }
    }); 
  }

  saveFA() {
    const loading = this.loadingCtrl.create({});
    loading.present().then(() => {
      let reimbursement = this.faForm.value;
      reimbursement.priority = null;
      if (this.existing_fa)  {
        reimbursement.id = this.existing_fa.id;
        this.dbPatient.updateReimbursement(this.program_id, this.patient.id, 'reimbursement_fa', reimbursement, this.user).then(() => {
          setTimeout(() => {
            loading.dismiss();
          },250);
        })
      } else {
        this.dbPatient.addReimbursement(this.program_id, this.patient.id, 'reimbursement_fa', reimbursement, this.user).then(() => {
          setTimeout(() => {
            loading.dismiss();
          },250);
        })
      }
    }); 
  }

  onFormChanges(): void {
    this.privateForm.controls['active'].valueChanges
    .takeUntil(this.ngUnsubscribe)
    .subscribe(() => {
      if(this.privateForm.controls['active'].value === 'Yes') {
        this.privateForm.get('active_date').setValidators([Validators.required]);
        this.privateForm.get('active_date').updateValueAndValidity();

        this.privateForm.get('inactive_date').setValidators(null);
        this.privateForm.get('inactive_date').setErrors(null);
        this.privateForm.get('inactive_date').updateValueAndValidity();

        this.privateForm.get('active_date').setValue(new Date());
        this.privateForm.get('inactive_date').setValue(null);
      } else {
        this.privateForm.get('inactive_date').setValidators([Validators.required]);
        this.privateForm.get('inactive_date').updateValueAndValidity();

        this.privateForm.get('active_date').setValidators(null);
        this.privateForm.get('active_date').setErrors(null);
        this.privateForm.get('active_date').updateValueAndValidity();

        this.privateForm.get('inactive_date').setValue(new Date());
        this.privateForm.get('active_date').setValue(null);
      }  
    });
  }


  onOtherFormChanges(): void {
    this.privateOtherForm.controls['active'].valueChanges
    .takeUntil(this.ngUnsubscribe)
    .subscribe(() => {
      if(this.privateOtherForm.controls['active'].value === 'Yes') {
        this.privateOtherForm.get('active_date').setValidators([Validators.required]);
        this.privateOtherForm.get('active_date').updateValueAndValidity();

        this.privateOtherForm.get('inactive_date').setValidators(null);
        this.privateOtherForm.get('inactive_date').setErrors(null);
        this.privateOtherForm.get('inactive_date').updateValueAndValidity();

        this.privateOtherForm.get('active_date').setValue(new Date());
        this.privateOtherForm.get('inactive_date').setValue(null);
      } else {
        this.privateOtherForm.get('inactive_date').setValidators([Validators.required]);
        this.privateOtherForm.get('inactive_date').updateValueAndValidity();

        this.privateOtherForm.get('active_date').setValidators(null);
        this.privateOtherForm.get('active_date').setErrors(null);
        this.privateOtherForm.get('active_date').updateValueAndValidity();

        this.privateOtherForm.get('inactive_date').setValue(new Date());
        this.privateOtherForm.get('active_date').setValue(null);
      }  
    });
  }

  onPublicFormChanges(): void {
    this.publicForm.controls['active'].valueChanges
    .takeUntil(this.ngUnsubscribe)
    .subscribe(() => {
      if(this.publicForm.controls['active'].value === 'Yes') {
        this.publicForm.get('active_date').setValidators([Validators.required]);
        this.publicForm.get('active_date').updateValueAndValidity();

        this.publicForm.get('inactive_date').setValidators(null);
        this.publicForm.get('inactive_date').setErrors(null);
        this.publicForm.get('inactive_date').updateValueAndValidity();

        this.publicForm.get('active_date').setValue(new Date());
        this.publicForm.get('inactive_date').setValue(null);
      } else {
        this.publicForm.get('inactive_date').setValidators([Validators.required]);
        this.publicForm.get('inactive_date').updateValueAndValidity();

        this.publicForm.get('active_date').setValidators(null);
        this.publicForm.get('active_date').setErrors(null);
        this.publicForm.get('active_date').updateValueAndValidity();

        this.publicForm.get('inactive_date').setValue(new Date());
        this.publicForm.get('active_date').setValue(null);
      }  
    });
  }

  onCompassionateFormChanges(): void {
    this.compassionateForm.controls['active'].valueChanges
    .takeUntil(this.ngUnsubscribe)
    .subscribe(() => {
      if(this.compassionateForm.controls['active'].value === 'Yes') {
        this.compassionateForm.get('active_date').setValidators([Validators.required]);
        this.compassionateForm.get('active_date').updateValueAndValidity();

        this.compassionateForm.get('inactive_date').setValidators(null);
        this.compassionateForm.get('inactive_date').setErrors(null);
        this.compassionateForm.get('inactive_date').updateValueAndValidity();

        this.compassionateForm.get('active_date').setValue(new Date());
        this.compassionateForm.get('inactive_date').setValue(null);
      } else {
        this.compassionateForm.get('inactive_date').setValidators([Validators.required]);
        this.compassionateForm.get('inactive_date').updateValueAndValidity();

        this.compassionateForm.get('active_date').setValidators(null);
        this.compassionateForm.get('active_date').setErrors(null);
        this.compassionateForm.get('active_date').updateValueAndValidity();

        this.compassionateForm.get('inactive_date').setValue(new Date());
        this.compassionateForm.get('active_date').setValue(null);
      }  
    });
  }

  onBridgingFormChanges(): void {
    this.bridgingForm.controls['active'].valueChanges
    .takeUntil(this.ngUnsubscribe)
    .subscribe(() => {
      if(this.bridgingForm.controls['active'].value === 'Yes') {
        this.bridgingForm.get('active_date').setValidators([Validators.required]);
        this.bridgingForm.get('active_date').updateValueAndValidity();

        this.bridgingForm.get('inactive_date').setValidators(null);
        this.bridgingForm.get('inactive_date').setErrors(null);
        this.bridgingForm.get('inactive_date').updateValueAndValidity();

        this.bridgingForm.get('active_date').setValue(new Date());
        this.bridgingForm.get('inactive_date').setValue(null);
      } else {
        this.bridgingForm.get('inactive_date').setValidators([Validators.required]);
        this.bridgingForm.get('inactive_date').updateValueAndValidity();

        this.bridgingForm.get('active_date').setValidators(null);
        this.bridgingForm.get('active_date').setErrors(null);
        this.bridgingForm.get('active_date').updateValueAndValidity();

        this.bridgingForm.get('inactive_date').setValue(new Date());
        this.bridgingForm.get('active_date').setValue(null);
      }  
    });
  }

  onFAFormChanges(): void {
    this.faForm.controls['active'].valueChanges
    .takeUntil(this.ngUnsubscribe)
    .subscribe(() => {
      if(this.faForm.controls['active'].value === 'Yes') {
        this.faForm.get('active_date').setValidators([Validators.required]);
        this.faForm.get('active_date').updateValueAndValidity();

        this.faForm.get('inactive_date').setValidators(null);
        this.faForm.get('inactive_date').setErrors(null);
        this.faForm.get('inactive_date').updateValueAndValidity();

        this.faForm.get('active_date').setValue(new Date());
        this.faForm.get('inactive_date').setValue(null);
      } else {
        this.faForm.get('inactive_date').setValidators([Validators.required]);
        this.faForm.get('inactive_date').updateValueAndValidity();

        this.faForm.get('active_date').setValidators(null);
        this.faForm.get('active_date').setErrors(null);
        this.faForm.get('active_date').updateValueAndValidity();

        this.faForm.get('inactive_date').setValue(new Date());
        this.faForm.get('active_date').setValue(null);
      }  
    });
  }
}



// WEBPACK FOOTER //
// ./src/components/patient-reimbursement/patient-reimbursement.ts